const paginationBuilder = (pagination: PaginationMeta) => {
	const links: Array<PaginationLink> = [
		{
			page: 1,
			label: '<<',
			active: false,
		},
		{
			page: pagination.current_page > 1 ? pagination.current_page - 1 : null,
			label: '<',
			active: false,
		},
	];

	const maxShow = 10;
	let startPage;
	let endPage;
	if (pagination.total_pages <= maxShow) {
		// total pages less than max so show all pages
		startPage = 1;
		endPage = pagination.total_pages;
	} else {
		// total pages more than max so calculate start and end pages
		const maxShowBeforeCurrentPage = Math.floor(maxShow / 2);
		const maxShowAfterCurrentPage = Math.ceil(maxShow / 2) - 1;
		if (pagination.current_page <= maxShowBeforeCurrentPage) {
			// current page near the start
			startPage = 1;
			endPage = maxShow;
		} else if (pagination.current_page + maxShowAfterCurrentPage >= pagination.total_pages) {
			// current page near the end
			startPage = pagination.total_pages - maxShow + 1;
			endPage = pagination.total_pages;
		} else {
			// current page somewhere in the middle
			startPage = pagination.current_page - maxShowBeforeCurrentPage;
			endPage = pagination.current_page + maxShowAfterCurrentPage;
		}
	}

	for (let page = startPage; page <= endPage; page++) {
		const link = {
			page,
			label: page,
			active: pagination.current_page === page,
		};
		links.push(link);
	}

	links.push(
		{
			page: pagination.current_page < pagination.total_pages ? pagination.current_page + 1 : null,
			label: '>',
			active: false,
		},
		{
			page: pagination.total_pages,
			label: '>>',
			active: false,
		}
	);

	return links;
};

export default paginationBuilder;
